<template>
  <a-drawer v-if="showDrawer"
            :width="500"
            placement="right"
            @close="closeDrawer"
            :visible="showDrawer">

    <h3>Apply Document to Other Sites</h3>

    <a-spin tip="Applying Document to selected sites"
            :spinning="spinning">
      <label>Current Site: {{ this.currentDocumentSite.label }}</label>
      <a-select
        style="width: 100%"
        placeholder="Select a site"
        mode="multiple"
        labelInValue
        :value="selectedSites"
        :notFoundContent="fetching ? undefined : null"
        @search="handleSearch"
        @focus="handleFocus"
        @change="selectSite"
      >
        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
        <a-select-option
          v-for="site in fetchedSites"
          :key="`${site.name}|fetchedSites|${site.id.toString()}`">
          {{site.name}}
        </a-select-option>
      </a-select>
    </a-spin>

    <div class="button-cont">
      <button type="button"
              class="btn btn-primary float-right"
              @click.prevent="applyDocumentToOtherSites()"
              :disabled="spinning">
        Apply
      </button>

      <button type="button"
              class="btn btn-danger float-right mr-2"
              @click="closeDrawer"
              :disabled="spinning">
        Close
      </button>
    </div>
  </a-drawer>
</template>

<script>
  import {mapState} from "vuex";
  import HTTPRequest from '../../../controllers/httpRequest.js';

  export default ({
    props: {
      documentNumber: Number,
      currentDocumentSite: Object,
      showDrawer: Boolean,
    },
    data() {
      return ({
        spinning: false,
        searchedInput: '',
        fetching: false,
        fetchedSites: [],
        selectedSites: [],
      })
    },
    mounted() {
      // this.fetchSites();
    },
    computed: {
      ...mapState(['endPoint', 'parentId', 'parameters', 'serverType', 'publicUrl']),
    },
    watch: {
      // searchedInput: function () {
      //   console.log("searchedInput")
      //   if (this.searchedInput.trim()) {
      //     this.fetch()
      //   } else {
      //     this.fetchedSites = []
      //   }
      // }
    },
    methods: {
      async setNotification(type, info) {
        this.$notification[type]({ message: info.message, description: info.description });
      },
      validate() {
        if (!this.selectedSites.length) {
          this.setNotification("error", { message: "Saving Failed", description: "No Selected Site" });
          return false;
        }

        return true;
      },
      async applyDocumentToOtherSites() {
        if (!this.validate()) { return; }

        this.spinning = true
        let requestBody = {
          document_number: this.documentNumber,
          site_ids: this.selectedSites.map(site => parseInt(site.key)),
        }

        let url = `${this.endPoint}documents/${this.documentNumber}/apply_to_other_sites`
        let postRequest = await HTTPRequest.postRequest(url, null, requestBody);
        this.spinning = false;
        if (postRequest.error) {
          this.setNotification("error", { message: "Saving Failed", description: postRequest.error });
        } else {
          this.closeDrawer();
          this.setNotification("success", { message: "Save Success", description: postRequest.error });
        }
      },
      closeDrawer() {
        this.$emit('closeDrawer', false)

        Object.assign(this, {
          selectedSites: [],
          fetchedSites: [],
          fetching: false,
        })
      },
      // async fetchSites() {
      //   if (this.fetchedSites.length > 0) { return }
      //   let fetchedSites = [];
      //   let selectedSiteIds = this.selectedSites.map(site => parseInt(site.key))
      //   selectedSiteIds.push(parseInt(this.currentDocumentSite.key));
      //   this.fetching = true
      //   fetchedSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
      //   fetchedSites.push({id: 0, code: 'All', name: 'All'})
      //   // fetchedSites.push({id: -1, code: 'Master', name: 'Master'})
      //   fetchedSites = fetchedSites.filter(site => ( !selectedSiteIds.includes(site.id) ))
      //   this.fetchedSites = fetchedSites
      //   this.fetching = false
      //   // fetchSites
      // },
      async fetchSites() {
        let fetchedSites = [];
        let selectedSiteIds = this.selectedSites.map(site => parseInt(site.key))
        selectedSiteIds.push(parseInt(this.currentDocumentSite.key));
        this.fetching = true
        fetchedSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', { name: this.searchedInput })
        if ('all'.includes(this.searchedInput.toLowerCase()))
          fetchedSites.push({id: 0, code: 'All', name: 'All'})
        // fetchedSites.push({id: -1, code: 'Master', name: 'Master'})
        fetchedSites = fetchedSites.filter(site => ( !selectedSiteIds.includes(site.id) ))
        this.fetchedSites = fetchedSites
        this.fetching = false
      },
      handleFocus(val) {
        this.fetchSites();
      },
      handleSearch(val) {
        this.searchedInput = val.trim();
        this.fetchSites();
      },
      async selectSite(sites) {
        if (sites.length > this.selectedSites.length) {
          let lastIndex = sites.length - 1;
          let newSite = sites[lastIndex];
          let parsedNewSite = newSite.key.split("|");
          // let key = parseInt(newSite.key.replace('fetchedSites',''));
          let key = parseInt(parsedNewSite[2]);
          if (key == 0) {
            let fetchedSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
            let selectedSiteIds = this.selectedSites.map(site => parseInt(site.key))
            let newSites = [];
            fetchedSites = fetchedSites.filter(site => ( !selectedSiteIds.includes(site.id) ))

            newSites = fetchedSites.map(site => ({
              key: site.id,
              label: site.name
            }))

            sites.pop();
            sites = [...sites, ...newSites];
          } else {
            let newSiteObj = {
              key: key,
              label: newSite.label
            }

            sites[lastIndex] = newSiteObj;
          }
        }

        Object.assign(this, {
          selectedSites: sites,
          fetchedSites: [],
          fetching: false,
          searchedInput: '',
        })
      }
      // selectSite
    }
  })
</script>

<style scoped>
.button-cont {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: -webkit-fill-available;
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
